import React, { useEffect, useState } from "react";
import { saveConsent, getConsent } from "../utils/cookies";
import "../Components/CookieConsent.css";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();

    if (!consent) {
      setVisible(true);
    } else {
      // If already accepted before → restore consent
      if (consent.analytics && window.gtag) {
        window.gtag("consent", "update", {
          ad_storage: "granted",
          analytics_storage: "granted",
        });
      }
    }
  }, []);

  const handleConsent = (analytics) => {
    saveConsent({ necessary: true, analytics });

    if (window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: analytics ? "granted" : "denied",
        analytics_storage: analytics ? "granted" : "denied",
      });
    }

    setVisible(false);

    // Reload required for GTM to re-fire correctly
    window.location.reload();
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <p>
        We use cookies to improve your experience and analyze traffic.
      </p>

      <div className="cookie-actions">
        <button
          className="btn ghost"
          onClick={() => handleConsent(false)}
        >
          Reject
        </button>

        <button
          className="btn primary"
          onClick={() => handleConsent(true)}
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
